import { render, staticRenderFns } from "./ruleofmetadata.vue?vue&type=template&id=0834cfa2"
import script from "./ruleofmetadata.vue?vue&type=script&lang=js"
export * from "./ruleofmetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports